export default __webpack_public_path__ + "static/cv-lucca-aa2dfc2545d99a682a428281eab0948a.pdf";